import { Component, Input, OnInit } from '@angular/core';
import { EventTrackerService } from '@app/core';
import { environment } from '@env/environment';

import { ListArtistModel } from './../pdp-model';

@Component({
  selector: 'navaar-agents-slider',
  templateUrl: './agents-slider.component.html',
  styleUrls: ['./agents-slider.component.scss', './../shared-style.scss']
})
export class AgentsSliderComponent implements OnInit {
  @Input() public items: Array<ListArtistModel> = [];
  @Input() public title: string;
  @Input() public audiobookId: number;
  @Input('location-screen-for-event-tracker') public location_screen: string = 'audiobook-detail';

  public environment = environment;

  constructor(
    public readonly eventTracker: EventTrackerService) { }

  ngOnInit() { }

  public goToListAgents() {
    this.eventTracker.logEvent('x_btn_goto_list_agents', {
      'audiobook-id': this.audiobookId,
      'title-slider': this.title,
    });
  }

  public trackByFn() {

  }

  public goToAgentsPage(id, title) {
    this.eventTracker.logEvent('x_slider_select_agent', {
      type: this.items.length > 3 ? 'slider' : 'card',
      'x_dest_item_id': id,
      'x_dest_item_title': title,
      'audiobook-id': this.audiobookId,
      'title-slider': this.title,
    });

  }
}
